import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import {
	actionGetHolidaysListFilters,
	actionDeleteHoliday,
	actionChangeHolidayProps,
	actionGetHolidaysList,
	actionUpdateHoliday
} from "../../actions/HolidayActions";
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn
} from "material-ui/Table";
import {
	HOLIDAYS_NEW,
	HOLIDAYS_EDIT,
	INDEX
} from "../../config/RoutesConstants";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../actions/ActionConstants";
import { Card, CardTitle, CardText } from "material-ui/Card";
import Util, { SUCCESS, ERROR } from "../../common/Util";
import AppMem from "../../common/AppMem";
import OptionsTableRowColumn from "../../components/OptionsTableRowColumn/OptionsTableRowColumn";
import FilterCard from "../../components/FilterCard/FilterCard";
import Paginator from "../../components/Paginator/Paginator";
import { ROL_ADMIN, ROL_SUB_ADMIN } from "../../common/Constants";

let limitePagina = 10;

class HolidaysIndex extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchFieldValue: "",
			showFilterCard: false,
			login: this.props.login,
			itemsList: [],
			holidaysList: !_.isEmpty(this.props.holidaysList)
				? this.props.holidaysList.splice(0, this.props.holidaysList.length)
				: []
		};
		this.handleSearch = this.handleSearch.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.onCreateOrUpdate = this.onCreateOrUpdate.bind(this);
		this.onTapConfirmDelete = this.onTapConfirmDelete.bind(this);
		this.getHolidays = this.getHolidays.bind(this);
		this.onChangePage = this.onChangePage.bind(this);
		this.onChangeSearch = this.onChangeSearch.bind(this);
		this.handleKeyPressSearchInput = this.handleKeyPressSearchInput.bind(this);
		this.renderBodyRows = this.renderBodyRows.bind(this);
	}

	componentWillMount() {
		if (this.props.rol !== ROL_ADMIN && this.props.rol !== ROL_SUB_ADMIN) {
			this.props.history.push(INDEX);
		} else this.getHolidays(1, limitePagina);
	}

	getHolidays(page, limit) {
		let { searchtext } = this.props;
		this.props.actionGetHolidaysList(searchtext, page, limit);
	}

	renderPaginator = () => {
		return (
			<Paginator
				page={this.props.page}
				pageLimit={limitePagina}
				total={this.props.total}
				onChangePage={this.onChangePage}
			/>
		);
	};

	onChangeSearch({ target: { value } }) {
		this.props.actionChangeHolidayProps({ searchtext: value });
	}

	handleKeyPressSearchInput(e) {
		if (e.key === "Enter") {
			this.handleSearch();
		}
	}

	handleSearch() {
		let activeFilters = false;
		//TODO
		// if (
		// 	this.props.vigenciaDesde !== null ||
		// 	this.props.vigenciaHasta !== null ||
		// 	this.props.activa !== 0
		// ) {
		// 	activeFilters = true;
		// }
		this.props.actionChangeHolidayProps({
			page: 1,
			activeFilters: activeFilters
		});
		this.getHolidays(1, limitePagina);
	}

	onCreateOrUpdate(holiday) {
		if (holiday) {
			this.props.actionChangeHolidayProps({
				holiday: holiday,
				modeCRU: MODE_CRU_UPDATE,
				searchtext: ""
			});
			this.props.history.push(HOLIDAYS_EDIT);
		} else {
			this.props.actionChangeHolidayProps({
				holiday: null,
				modeCRU: MODE_CRU_CREATE,
				searchtext: ""
			});
			this.props.history.push(HOLIDAYS_NEW);
		}
	}

	returnFormatDate(date) {
		return Util.formatDateToShow(date);
	}

	handleDelete(holiday) {
		AppMem.confirmDialog.open({
			title: "Eliminar Feriado",
			messageConfirm:
				"¿Esta seguro que desea eliminar el Feriado " + holiday.name + "?",
			onAccept: this.onTapConfirmDelete.bind(this, holiday.id)
		});
	}

	handleShow(holiday) {
		this.props.actionChangeHolidayProps({
			modeCRU: MODE_CRU_SHOW,
			holiday: holiday
		});
		this.props.history.push(HOLIDAYS_EDIT);
		//this.props.history.push(HOLIDAYS_EDIT + holiday.id);
	}

	onTapConfirmDelete(holidayId) {
		this.props.actionDeleteHoliday(
			holidayId,
			this.returnConfirmDelete.bind(this)
		);
	}

	returnConfirmDelete(response) {
		if (response === SUCCESS) {
			this.getHolidays(this.props.page, limitePagina);
			Util.showNoty(response, "Feriado Eliminado");
		} else if (response === ERROR) {
			Util.showNoty(response, "Error al eliminar feriado");
		} else {
			Util.showNoty(
				response,
				"No se puede eliminar feriado, tiene elementos asociados"
			);
		}
	}

	renderBlank() {
		let mensaje = "";
		if (this.props.busquedaRealizada) {
			mensaje = "No se encontraron resultados";
		} else {
			mensaje = "Aplique un criterio de búsqueda para visualizar datos";
		}
		return (
			<TableRow key={1}>
				<TableRowColumn>
					<p>{mensaje}</p>
				</TableRowColumn>
			</TableRow>
		);
	}

	onChangePage(page) {
		this.props.actionChangeHolidayProps({
			page: page
		});
		this.getHolidays(page, limitePagina);
	}

	returnToggle(response) {
		if (response === SUCCESS) {
			Util.showNoty(SUCCESS, "Feriado modificado");
		} else if (response === ERROR) {
			Util.showNoty(ERROR, "Error al modificar feriado");
		}
	}

	renderBodyRows(holidaysList) {
		let Edit = this.onCreateOrUpdate;
		let Delete = this.handleDelete;
		const Show = this.handleShow;
		return _.map(holidaysList, (holiday, i) => {
			return (
				<TableRow key={i} style={{ height: "16px", fontSize: "12px" }}>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{holiday.name}
					</TableRowColumn>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{Util.formatDateToShowNotHour(holiday.date)}
					</TableRowColumn>
					<TableRowColumn style={{ width: "20%" }}>
						<OptionsTableRowColumn
							handleEdit={() => Edit(holiday)}
							handleDelete={() => Delete(holiday)}
							handleShow={() => Show(holiday)}
						/>
					</TableRowColumn>
				</TableRow>
			);
		});
	}

	render() {
		return (
			<div className="center">
				<Card className="card">
					<CardTitle title="Feriado" subtitle="Agregue o Modifique feriados" />
					<CardText>
						<FilterCard
							onChangeSearchField={this.onChangeSearch}
							InputValue={this.props.searchtext}
							onKeyPressSearchField={this.handleKeyPressSearchInput}
							onTouchTapSearch={() => this.handleSearch(this.props.searchtext)}
							onTouchTapNew={() => this.onCreateOrUpdate()}
						/>
						<Table selectable={false}>
							<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
								<TableRow>
									<TableHeaderColumn>Nombre de Feriado</TableHeaderColumn>
									<TableHeaderColumn>Fecha del Feriado</TableHeaderColumn>
									<TableHeaderColumn style={{ width: "20%" }}>
										Acciones
									</TableHeaderColumn>
								</TableRow>
							</TableHeader>
							<TableBody stripedRows displayRowCheckbox={false}>
								{!_.isEmpty(this.props.holidaysList)
									? this.renderBodyRows(this.props.holidaysList)
									: this.renderBlank()}
							</TableBody>
						</Table>
					</CardText>
					{!_.isEmpty(this.props.holidaysList) ? this.renderPaginator() : ""}
				</Card>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		searchtext: store.holiday.searchtext,
		holidaysList: store.holiday.holidaysList,
		loadingText: store.holiday.loadingText,
		busquedaRealizada: store.holiday.busquedaRealizada,
		activeFilters: store.holiday.activeFilters,
		modeCRU: store.holiday.modeCRU,
		page: store.holiday.page,
		login: store.session.authenticated,
		total: store.holiday.total,
		rol: store.app.rol
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionGetHolidaysListFilters,
			actionDeleteHoliday,
			actionChangeHolidayProps,
			actionGetHolidaysList,
			actionUpdateHoliday
		},
		dispatch
	);
}
export default connect(mapStateToProps, mapDispatchToProps)(HolidaysIndex);



// WEBPACK FOOTER //
// ./src/screens/Holiday/HolidayIndex.js